import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Layout from '../components/Layout';
import '../styles/page-layout.css';

const BadRequestPage: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const error = searchParams.get('error') || 'Ungültige Anfrage';

  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  };

  return (
    <Layout
      title="Ungültige Anfrage | Stimm.DEV"
      description="Die Anfrage konnte nicht verarbeitet werden. Bitte überprüfen Sie die eingegebenen Daten."
      keywords="400, Ungültige Anfrage, Fehlerhafte Eingabe"
    >
      <section className="wrapper">
        <div className="page-container" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h1 style={{ 
              fontSize: '6rem', 
              fontWeight: '800', 
              background: 'linear-gradient(135deg, #e67e22, #d35400)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              marginBottom: '1rem'
            }}>
              400
            </h1>
            
            <h2 style={{ 
              fontSize: '2rem', 
              marginBottom: '1rem',
              color: 'var(--text-color)'
            }}>
              Ungültige Anfrage
            </h2>
            
            <p style={{ 
              fontSize: '1.1rem', 
              color: 'var(--text-muted)',
              marginBottom: '1rem',
              lineHeight: '1.6'
            }}>
              Die Anfrage konnte nicht verarbeitet werden. 
              Möglicherweise sind die übermittelten Daten fehlerhaft 
              oder unvollständig.
            </p>

            {error !== 'Ungültige Anfrage' && (
              <div style={{
                padding: '1rem',
                background: 'var(--error-color-light)',
                borderRadius: '0.5rem',
                border: '1px solid var(--error-color)',
                marginBottom: '2rem',
                color: 'var(--text-color)'
              }}>
                <strong>Fehlerdetails:</strong> {error}
              </div>
            )}

            <div style={{ 
              display: 'flex', 
              gap: '1rem', 
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginBottom: '3rem'
            }}>
              <button 
                onClick={handleGoBack}
                className="primary-button"
                style={{ 
                  border: 'none',
                  cursor: 'pointer',
                  background: 'var(--primary-color)',
                  color: 'white'
                }}
              >
                <i className="fas fa-arrow-left" style={{ marginRight: '0.5rem' }}></i>
                Zurück
              </button>
              
              <Link 
                to="/" 
                className="secondary-button"
                style={{ textDecoration: 'none' }}
              >
                <i className="fas fa-home" style={{ marginRight: '0.5rem' }}></i>
                Zur Startseite
              </Link>
            </div>

            <div style={{ 
              padding: '2rem',
              background: 'var(--card-background)',
              borderRadius: '1rem',
              border: '1px solid var(--border-color)',
              textAlign: 'left'
            }}>
              <h3 style={{ marginBottom: '1rem', color: 'var(--text-color)' }}>
                <i className="fas fa-exclamation-triangle" style={{ marginRight: '0.5rem', color: 'var(--warning-color)' }}></i>
                Häufige Ursachen:
              </h3>
              
              <ul style={{ 
                color: 'var(--text-muted)',
                lineHeight: '1.8',
                paddingLeft: '1.5rem'
              }}>
                <li>Fehlende oder ungültige Parameter in der URL</li>
                <li>Falsch formatierte Formulardaten</li>
                <li>Ungültige Zeichen in der Eingabe</li>
                <li>Überschreitung von Längenbegrenzungen</li>
                <li>Veralteter oder manipulierter Link</li>
              </ul>

              <div style={{ 
                marginTop: '2rem',
                padding: '1rem',
                background: 'var(--info-color-light)',
                borderRadius: '0.5rem',
                borderLeft: '4px solid var(--info-color)'
              }}>
                <strong style={{ color: 'var(--text-color)' }}>
                  <i className="fas fa-lightbulb" style={{ marginRight: '0.5rem' }}></i>
                  Lösungsvorschläge:
                </strong>
                <div style={{ marginTop: '0.5rem', color: 'var(--text-muted)' }}>
                  <p style={{ margin: '0.25rem 0' }}>• Überprüfen Sie die eingegebenen Daten</p>
                  <p style={{ margin: '0.25rem 0' }}>• Verwenden Sie die Navigation der Website</p>
                  <p style={{ margin: '0.25rem 0' }}>• Kontaktieren Sie uns bei wiederkehrenden Problemen</p>
                </div>
              </div>

              <div style={{ 
                marginTop: '1rem',
                textAlign: 'center'
              }}>
                <a 
                  href="mailto:support@stimm.dev?subject=400 Fehler - Ungültige Anfrage"
                  style={{ 
                    color: 'var(--primary-color)', 
                    textDecoration: 'none',
                    fontSize: '0.9rem'
                  }}
                >
                  <i className="fas fa-envelope" style={{ marginRight: '0.5rem' }}></i>
                  Problem melden
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BadRequestPage;
